exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-react-wave-animation-animating {\n  position: relative; }\n  .xue-react-wave-animation-animating::before {\n    content: '';\n    display: block;\n    background-color: inherit;\n    pointer-events: none;\n    position: absolute;\n    z-index: 1;\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    right: -1px;\n    border-radius: inherit;\n    border: 0 solid;\n    border-color: inherit;\n    opacity: 0.3;\n    animation: xue-react-wave-animation 0.3s ease-in-out forwards;\n    flex-shrink: 0; }\n\n@keyframes xue-react-wave-animation {\n  to {\n    top: -6px;\n    left: -6px;\n    bottom: -6px;\n    right: -6px;\n    border-width: 6px;\n    opacity: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/style/wave.scss
// module id = 70
// module chunks = 0